//
//
//
//
//
//
//
//
//
//


import PageDefault from './PageDefault.vue';
import PageHome from './PageHome.vue';
import PageAbout from './PageAbout.vue';
import PageHistory from './PageHistory.vue';
import PageMaking from './PageMaking.vue';
import PageProduction from './PageProduction.vue';
import PageBrands from './PageBrands.vue';
import PageCatalog from './PageCatalog.vue';
import PageNews from './PageNews.vue';
import PageMaterials from './PageMaterials.vue';
import PageRecipes from './PageRecipes.vue';
import PageCooperation from './PageCooperation.vue';
import PageCareer from './PageCareer.vue';
import PageContacts from './PageContacts.vue';
import PageOvsyanoe from './PageOvsyanoe.vue';
import PageSearch from './PageSearch.vue';
import PageRobots from './PageRobots.vue';
import BtnTop from '../BtnTop.vue';

export default {
	name: 'PageWrap',

	components: {
		PageDefault: PageDefault,
		PageHome: PageHome,
		PageAbout: PageAbout,
		PageHistory: PageHistory,
		PageMaking: PageMaking,
		PageProduction: PageProduction,
		PageBrands: PageBrands,
		PageCatalog: PageCatalog,
		PageNews: PageNews,
		PageMaterials: PageMaterials,
		PageRecipes: PageRecipes,
		PageCooperation: PageCooperation,
		PageCareer: PageCareer,
		PageContacts: PageContacts,
		PageSearch: PageSearch,
		PageOvsyanoe: PageOvsyanoe,
		PageRobots: PageRobots,
		BtnTop: BtnTop
	},

	props: {
		page: {
			default: function _default() {
				return {};
			}
		}
	},

	computed: {
		pageType: function pageType() {
			return this.page.code || 'page-default';
		},
		crumbs: function crumbs() {
			if ('breadcrumbs' in this.page) {
				return this.page.breadcrumbs;
			}
			return [{ route: this.$route.fullPath, title: this.page.title }];
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageWrap.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageWrap.vue
// module chunks = 0